"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarTheme = void 0;
// @ts-nocheck
const core_1 = require("@material-ui/core");
const theme_1 = require("./theme");
exports.calendarTheme = ((theme) => {
    const primaryColor = theme.palette.primary.main;
    const primaryColor54 = (0, core_1.alpha)(primaryColor, 0.54);
    return (0, core_1.createTheme)({
        palette: {
            primary: {
                main: theme.palette.primary.main,
            },
            info: {
                main: theme.palette.primary.main,
            },
        },
        overrides: {
            // @ts-ignore
            MuiPickersToolbarText: {
                toolbarTxt: {
                    color: primaryColor54,
                },
                toolbarBtnSelected: {
                    color: primaryColor,
                },
            },
            MuiPickersToolbar: {
                toolbar: {
                    backgroundColor: theme_1.colors.ghostWhite,
                },
            },
            MuiInputBase: {
                input: {
                    padding: 0,
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: 'normal',
                    color: theme_1.colors.black0,
                    '&::placeholder': {
                        fontSize: 16,
                        fontWeight: 400,
                        color: theme_1.colors.black35,
                        opacity: 1,
                    },
                },
            },
            MuiInput: {
                underline: {
                    '&:before': {
                        borderBottom: 'none !important',
                        content: '""',
                    },
                    '&:after': {
                        borderBottom: 'none',
                    },
                },
            },
        },
    });
});
//# sourceMappingURL=CalendarTheme.js.map